import { Popover } from '@src/components/Popover';
import React from 'react';
import { IoInformationCircle } from 'react-icons/io5';

const NotApplicable = ({ content }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      gap: 5,
    }}
  >
    <p style={{ textAlign: 'center', fontSize: '0.85rem', marginBottom: 0 }}>
      <strong>N/A</strong>
    </p>
    <Popover
      trigger={
        <IoInformationCircle
          style={{ position: 'absolute', marginLeft: 20, top: -4, color: '#23d4ff' }}
          size={20}
        />
      }
      position="top"
      align="center"
    >
      <p>{content}</p>
    </Popover>
  </div>
);

export default NotApplicable;
